<template>
    <div>
        <form ref="cardHorizontalForm"  class="card-horizontal__form" action="#" v-if="selfPets.length && user">
            <fieldset class="card-horizontal__form-fieldset d-flex">

                <div class="card-horizontal__form-item">
                    <date-picker v-model="$v.cardHorizontalForm.timeTo.$model" value-type="format" format="YYYY-MM-DD 20:00:00" :placeholder="$store.getters.t('card_horizontal_form_actual_till')"></date-picker>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.timeTo.$error">{{$store.getters.t('card_horizontal_form_date_cannot_be_past')}}</div>
                </div>

                <div class="card-horizontal__form-item">
                    <input type="text" v-model="$v.cardHorizontalForm.phone.$model"
                           v-mask="'+1 (###) ###-####'" placeholder="+1 (999) 999-9999">
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.phone.$error">{{$store.getters.t('card_horizontal_form_phone_invalid')}}</div>
                </div>

            </fieldset>

            <fieldset class="card-horizontal__form-fieldset d-flex" v-if="page === 'homestays'">

                <div class="card-horizontal__form-item">
                    <date-picker v-model="$v.cardHorizontalForm.homestayDateFrom.$model" value-type="format" format="YYYY-MM-DD 20:00:00" :placeholder="$store.getters.t('card_horizontal_form_from_date')"></date-picker>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.homestayDateFrom.$error">{{$store.getters.t('card_horizontal_form_wrong_date')}}</div>
                </div>

                <div class="card-horizontal__form-item">
                    <date-picker v-model="$v.cardHorizontalForm.homestayDateTo.$model" value-type="format" format="YYYY-MM-DD 20:00:00" :placeholder="$store.getters.t('card_horizontal_form_to_date')"></date-picker>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.homestayDateTo.$error">{{$store.getters.t('card_horizontal_form_wrong_date')}}</div>
                </div>

            </fieldset>

            <fieldset class="card-horizontal__form-fieldset d-flex" v-if="page === 'facility' && sendObj.type !== 'giveaway'">

                <div class="card-horizontal__form-item">
                    <date-picker v-model="$v.cardHorizontalForm.facilityDateFrom.$model" value-type="format" format="YYYY-MM-DD 20:00:00" :placeholder="$store.getters.t('card_horizontal_form_from_date')"></date-picker>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.facilityDateFrom.$error">{{$store.getters.t('card_horizontal_form_wrong_date')}}</div>
                </div>

                <div class="card-horizontal__form-item">
                    <date-picker v-model="$v.cardHorizontalForm.facilityDateTo.$model" value-type="format" format="YYYY-MM-DD 20:00:00" :placeholder="$store.getters.t('card_horizontal_form_to_date')"></date-picker>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.facilityDateTo.$error">{{$store.getters.t('card_horizontal_form_wrong_date')}}</div>
                </div>

            </fieldset>


            <!-- Список реципиентов -->
            <fieldset class="card-horizontal__form-fieldset" v-if="page === 'donors'">
                <div class="card-horizontal__form-item">

                    <select v-model="$v.cardHorizontalForm.recipient.$model">
                        <option value="-1" disabled>{{$store.getters.t('card_horizontal_form_choose_recipient')}}</option>
                        <option :value="pet.id" v-for="pet in selfPets" :key="pet.id">{{pet.name}}</option>
                    </select>

                    <div class="field-error-text" v-if="$v.cardHorizontalForm.recipient.$error">{{$store.getters.t('card_horizontal_form_choose_recipient')}}</div>
                </div>
            </fieldset>


            <fieldset class="card-horizontal__form-fieldset" v-if="page === 'homestays'">
                <div class="card-horizontal__form-item">

                    <select v-model="$v.cardHorizontalForm.homestayPetId.$model">
                        <option value="-1" disabled>{{$store.getters.t('card_horizontal_form_choose_pet')}}</option>
                        <option :value="pet.id" v-for="pet in selfPets" :key="pet.id">{{pet.name}}</option>
                    </select>

                    <div class="field-error-text" v-if="$v.cardHorizontalForm.homestayPetId.$error">{{$store.getters.t('card_horizontal_form_choose_pet')}}</div>
                </div>
            </fieldset>

            <fieldset class="card-horizontal__form-fieldset d-flex" v-if="page === 'facility'">
                <div class="card-horizontal__form-item" v-if="selfPets.length">

                    <select v-model="$v.cardHorizontalForm.facilityPetId.$model" :disabled="cardHorizontalForm.facilityProjectId > 0">
                        <option value="-1">{{$store.getters.t('card_horizontal_form_choose_pet')}}</option>
                        <option :value="pet.id" v-for="pet in selfPets" :key="pet.id">{{pet.name}}</option>
                    </select>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.facilityPetId.$error">{{$store.getters.t('card_horizontal_form_choose_pet')}}</div>
                </div>

                <div class="card-horizontal__form-item" v-if="selfProjects.length">

                    <select v-model="$v.cardHorizontalForm.facilityProjectId.$model" :disabled="cardHorizontalForm.facilityPetId > 0">
                        <option value="-1">{{$store.getters.t('card_horizontal_form_choose_project')}}</option>
                        <option :value="project.id" v-for="project in selfProjects" :key="project.id">{{project.name}}</option>
                    </select>
                    <div class="field-error-text" v-if="$v.cardHorizontalForm.facilityProjectId.$error">{{$store.getters.t('card_horizontal_form_choose_project')}}</div>
                </div>


            </fieldset>



            <fieldset class="card-horizontal__form-fieldset">
                <div class="card-horizontal__form-item card-horizontal__form-item--full">
                    <textarea rows="4" name="comment" v-model="$v.cardHorizontalForm.comment.$model" :placeholder="$store.getters.t('card_horizontal_form_leave_comment')"></textarea>
                </div>
            </fieldset>

            <fieldset class="card-horizontal__form-fieldset" v-if="page === 'donors'">
                <div class="card-horizontal__form-item card-horizontal__form-item--full">
                    <button :disabled="sendStatus === 'pending' || sendStatus === 'failed' || sendStatus === 'success'" @click.prevent="donorSubmit(sendObj.id)"
                            :style="{background: statusType.color}"
                            class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary"
                    >{{statusType.text}}</button>
                </div>
            </fieldset>


            <fieldset class="card-horizontal__form-fieldset" v-if="page === 'homestays'">
                <div class="card-horizontal__form-item card-horizontal__form-item--full">
                    <button :disabled="sendStatus === 'pending' || sendStatus === 'failed' || sendStatus === 'success'"  @click.prevent="homestaySubmit(sendObj.id)"
                            :style="{background: statusType.color}"
                            class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary"
                    >{{statusType.text}}</button>
                </div>
            </fieldset>


            <fieldset class="card-horizontal__form-fieldset" v-if="page === 'facility'">
                <div class="card-horizontal__form-item card-horizontal__form-item--full">
                    <button :disabled="sendStatus === 'pending' || sendStatus === 'failed' || sendStatus === 'success'"  @click.prevent="facilitySubmit(sendObj.id)"
                            :style="{background: statusType.color}"
                            class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary"
                    >{{statusType.text}}</button>
                </div>
            </fieldset>


        </form>
        <div class="field-error-text" v-else>
            {{$store.getters.t('card_horizontal_form_register_ward_to_submit')}}
        </div>
    </div>
</template>

<script>

import {mask} from 'vue-the-mask'
import {numeric,helpers, required, minLength, requiredIf} from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
const phoneValidator = helpers.regex('phone', /^(?:\+1\s\(\d{3}\)\s[1-9]\d{2}-\d{2}-\d{2}|\+34\s[6789]\d{2}\s\d{3}\s\d{3})$/g);


export default {
    name: "CardHorizontalForm",
    props: ['sendObj', 'selfPets', 'page', 'user', "selfProjects"],
    components:{
        DatePicker
    },
    directives: {mask},
    data(){
        return{
            sendStatus: 'wait_sending',
            sendForm: false,
            cardHorizontalForm:{
                timeTo: null,
                homestayDateFrom: null,
                homestayDateTo: null,
                homestayPetId: -1,
                comment: '',
                recipient: -1,
                phone: null,


                facilityDateFrom: null,
                facilityDateTo: null,
                facilityPetId: -1,
                facilityProjectId: -1,
            }
        }
    },
    computed:{
        statusType(){
            let status = {}

            switch (this.sendStatus){
                case 'wait_sending':
                    status = {
                        text: this.$store.getters.t('card_horizontal_form_send'),
                        color: '#2E76E4'
                    }
                    break;
                case 'pending':
                    status = {
                        text: this.$store.getters.t('card_horizontal_form_sending'),
                        color: '#2E76E4'
                    }
                    break;
                case 'success':
                    status = {
                        text: this.$store.getters.t('card_horizontal_form_sent'),
                        color: '#77de51'
                    }
                    break;
                case 'failed':
                    status = {
                        text: this.$store.getters.t('common_error'),
                        color: '#EE7372'
                    }
                    break;
                default:
                    break;
            }

            return status

        },

        type(){

            let type = this.sendObj.type;

            switch (type){
                case 'photo_help':
                    type = 'photo-help'
                    break;
                case 'pr_help':
                    type = 'pr-help'
                    break;
                case 'auto_help':
                    type = 'auto-help'
                    break;
                case 'giveaway':
                    type = 'giveaway'
                    break;
                default:
                    type = ''
            }


            return type


        }

    },

    methods:{

        facilitySubmit(id){

            this.$v.cardHorizontalForm.$touch();

            if (this.$v.cardHorizontalForm.$invalid) {
                this.sendStatus = 'wait_sending'
                return false;
            }

            let url = `/api/interactions/${this.type}/apply`,
                phone = this.cardHorizontalForm.phone ? this.cardHorizontalForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'') : null,
                subjectType = this.cardHorizontalForm.facilityPetId > 0 ? 'App\\Models\\Pet' :
                                    this.cardHorizontalForm.facilityProjectId > 0 ? 'App\\Models\\Project' : null,
                data = new FormData();


            data.append('subject_type', subjectType)
            data.append('subject_id', subjectType.indexOf('Pet') >= 0 ? this.cardHorizontalForm.facilityPetId : this.cardHorizontalForm.facilityProjectId)
            data.append('facility_id', id)
            data.append('actual_till', this.cardHorizontalForm.timeTo)
            data.append('comment', this.cardHorizontalForm.comment)
            data.append('details[phone]', phone)

            if(this.sendObj.type !== 'giveaway'){
                data.append('details[date_from]', this.cardHorizontalForm.facilityDateFrom)
                data.append('details[date_to]', this.cardHorizontalForm.facilityDateTo)
            }

            axios.post(url,data,{
                header:{
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.sendStatus = 'success';

                        setTimeout(()=>{
                            this.sendStatus = 'wait_sending';

                            this.cardHorizontalForm ={
                                timeTo: null,
                                comment: null,
                                facilityPetId: -1,
                                facilityProjectId: -1,
                                facilityDateTo: null,
                                facilityDateFrom: null,
                                phone: null,
                            }

                            this.$v.cardHorizontalForm.$reset()

                        }, 3000)
                    }
                })
                .catch(error => {
                    error = error.response.data
                    if(!error.success){
                        alert(error.message)
                        this.sendStatus = 'failed';

                        setTimeout(() => {
                            this.sendStatus = 'wait_sending';

                            this.cardHorizontalForm = {
                                timeTo: null,
                                comment: null,
                                facilityPetId: -1,
                                facilityProjectId: -1,
                                facilityDateTo: null,
                                facilityDateFrom: null,
                                phone: null,
                            }
                            this.$v.cardHorizontalForm.$reset()
                        }, 3000)
                    }
                })
        },

        homestaySubmit(id){
            this.$v.cardHorizontalForm.$touch();

            if (this.$v.cardHorizontalForm.$invalid) {
                this.sendStatus = 'wait_sending'
                return false;
            }

            let self = this,
                url = `/api/interactions/homestay/apply`,
                phone = this.cardHorizontalForm.phone ? this.cardHorizontalForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'') : null,
                data = new FormData();


            data.append('homestay_id', id)
            data.append('pet_id', this.cardHorizontalForm.homestayPetId)
            data.append('actual_till', this.cardHorizontalForm.timeTo)
            data.append('comment', this.cardHorizontalForm.comment)
            data.append('details[phone]', phone)
            data.append('details[date_from]', this.cardHorizontalForm.homestayDateFrom)
            data.append('details[date_to]', this.cardHorizontalForm.homestayDateTo)


            axios.post(url, data,{
                header:{
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.sendStatus = 'success';

                        setTimeout(()=>{
                            this.sendStatus = 'wait_sending';


                            this.cardHorizontalForm ={
                                timeTo: null,
                                comment: null,
                                homestayPetId: -1,
                                homestayDateTo: null,
                                homestayDateFrom: null,
                                phone: null,
                            }

                            self.$v.cardHorizontalForm.$reset()

                        }, 3000)
                    }
                })
                .catch(error => {
                    error = error.response.data
                    if(!error.success){
                        this.sendStatus = 'failed';
                        alert(error.message);

                        setTimeout(() => {
                            this.sendStatus = 'wait_sending';

                            this.cardHorizontalForm = {
                                timeTo: null,
                                comment: null,
                                homestayPetId: -1,
                                homestayDateTo: null,
                                homestayDateFrom: null,
                                phone: null,
                            }
                            this.$v.cardHorizontalForm.$reset()
                        }, 3000);
                    }
                })
        },

        donorSubmit(id){

            this.$v.cardHorizontalForm.$touch();

            if (this.$v.cardHorizontalForm.$invalid) {
                this.sendStatus = 'wait_sending'
                return false;
            }

            let self = this,
                url = `/api/interactions/donorship/apply`,
                phone = this.cardHorizontalForm.phone ? this.cardHorizontalForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'') : null,
                data = new FormData();

            data.append('donor_pet_id', id)
            data.append('recipient_pet_id', this.cardHorizontalForm.recipient)
            data.append('actual_till', this.cardHorizontalForm.timeTo)
            data.append('comment', this.cardHorizontalForm.comment)
            data.append('details[phone]', phone)


            this.sendStatus = 'pending'

            axios.post(url, data,{
                header:{
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response =>{
                    response = response.data
                    if (response.success){
                        this.sendStatus = 'success';

                        setTimeout(()=>{
                            this.sendStatus = 'wait_sending';


                            this.cardHorizontalForm ={
                                timeTo: null,
                                comment: null,
                                recipient: -1,
                                phone: null,
                            }

                            self.$v.cardHorizontalForm.$reset()

                        }, 3000)
                    }


                })
                .catch(error=>{
                    let response = error.response.data

                    if(!response.success){
                        alert(response.message)
                        self.sendStatus = 'failed';

                        setTimeout(() => {
                            this.sendStatus = 'wait_sending';

                            this.cardHorizontalForm = {
                                timeTo: null,
                                comment: null,
                                recipient: -1,
                                phone: null,
                            }
                            self.$v.cardHorizontalForm.$reset()
                        }, 3000);
                    }

                })

        },
    },

    validations: {
        cardHorizontalForm: {
            timeTo: {
                required,
                minValue: function (value){
                    return value > new Date().toISOString()
                }
            },
            homestayDateFrom:{
                required: requiredIf(function(value){
                    if(this.page === 'homestays') return true

                    return false

                }),
                minValue: function (value){

                    if(this.page !== 'homestays') return true

                    return value > new Date().toISOString()
                }
            },

            homestayDateTo:{
                required: requiredIf(function(value){
                    if(this.page === 'homestays') return true

                    return false

                }),
                minValue: function (value){
                    if(this.page !== 'homestays') return true

                    return value > new Date().toISOString() && value > this.cardHorizontalForm.homestayDateFrom
                }
            },
            homestayPetId: {
                required: requiredIf(function(value){
                    if(this.page === 'homestays') return true

                    return false

                }),
                minValue: function (value){
                    if(this.page !== 'homestays') return true

                    return value > 0
                }
            },

            facilityPetId: {
                required: requiredIf(function(value){
                    if(this.page === 'facility' && this.cardHorizontalForm.facilityProjectId < 0) return true

                    return false

                }),
                minValue: function (value){
                    if(this.page !== 'facility' || this.cardHorizontalForm.facilityProjectId > 0) return true

                    return value > 0
                }
            },


            facilityProjectId: {
                required: requiredIf(function(value){
                    if(this.page === 'facility' && this.cardHorizontalForm.facilityPetId < 0) return true

                    return false

                }),
                minValue: function (value){
                    if(this.page !== 'facility' || this.cardHorizontalForm.facilityPetId > 0) return true

                    return value > 0
                }
            },

            facilityDateFrom:{
                required: requiredIf(function(value){
                    if(this.page === 'facility' && this.sendObj.type !== 'giveaway') return true

                    return false

                }),
                minValue: function (value){

                    if(this.page !== 'facility') return true
                    if(this.page === 'facility' && this.sendObj.type === 'giveaway') return true

                    return value > new Date().toISOString()
                }
            },

            facilityDateTo:{
                required: requiredIf(function(value){
                    if(this.page === 'facility'  && this.sendObj.type !== 'giveaway') return true

                    return false

                }),
                minValue: function (value){

                    if(this.page !== 'facility') return true
                    if(this.page === 'facility' && this.sendObj.type === 'giveaway') return true

                    return value > new Date().toISOString() && value > this.cardHorizontalForm.facilityDateFrom
                }
            },


            phone: {
                required,
                phoneValidator
            },
            comment: {},
            recipient: {
                required: requiredIf(function(value){
                    if(this.page === 'donors') return true

                    return false

                }),
            }
        },
    },

}
</script>

<style scoped>

</style>
